import { PropsWithChildren } from 'react';
import { ThemeProvider, lightTheme, brandGradientTokens } from '@bettercomp/ui-components';

/**
 * Canonical base theme for the app. `inherit: false` detaches from any ancestor
 * ConfigProvider (e.g. the dark header theme), so this yields the same light
 * theme wherever it is mounted — including a Drawer/Popover that React-portals
 * out of the dark header subtree. Single place that knows lightTheme /
 * brandGradientTokens (and where per-client theme loading will live later).
 *
 * Note: `brandGradientTokens` reach non-portaled DOM descendants only (they are
 * set via CSS inheritance on a wrapper element); antd color tokens (`--bc-color-*`)
 * reach portaled content because antd stamps the cssVar class on the element
 * itself. Do not rely on `--bc-brand-gradient-*` inside a portaled component.
 */
export function AppThemeProvider({ children }: PropsWithChildren) {
  return (
    <ThemeProvider theme={{ ...lightTheme, inherit: false }} customTokens={brandGradientTokens}>
      {children}
    </ThemeProvider>
  );
}
